
import ModalWindow from '@/ui-kit/components/modal/modal-window';
import ModalCommonProps from '@/ui-kit/components/modal/mixins/ModalCommonProps';
import { ModalSlotName } from '@/ui-kit/components/modal/enums';
import Typography from '@/ui-kit/components/typography';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import Button from '@/ui-kit/components/button';
import { ButtonFillType } from '@/ui-kit/components/button/enums';
import RadioGroup from '@/ui-kit/components/form/controls/components/radio';
import { BUYER_TYPE_OPTIONS } from './constants';

export default {
  name: 'ListingOwnerContactsUserRoleModal',
  components: {
    ModalWindow,
    Typography,
    RadioGroup,
    Button,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
      TypographyType,
      StyleColorSchemeType,
      ButtonFillType,
      BUYER_TYPE_OPTIONS,
      userRole: null,
    };
  },
  methods: {
    handleStartClick() {
      this.closeHandler(this.userRole);
    },
    handleBuyerTypeChange(value) {
      this.userRole = value;
    },
  },
};
